var _quizUrlForIFrame = null

const notifyParentOfHeight = function (height) {
  if (window.parent !== window) {
    if (!_quizUrlForIFrame) {
      const urlHolder = document.getElementsByClassName('js__quizUrlForIFrameHolder')[0]
      if (urlHolder) { _quizUrlForIFrame = urlHolder.getAttribute('data-quiz-iframe-url') }
    }
    window.parent.postMessage(JSON.stringify({ sizing: height, url: _quizUrlForIFrame || window.location.href }), '*')
  }
}

var __lastSentHeight = -1
const checkHeightAndNotifyParent = function () {
  if (!document.body) return

  const newHeight = document.body.clientHeight + 40
  if (__lastSentHeight !== newHeight) {
    __lastSentHeight = newHeight
    notifyParentOfHeight(newHeight)
  }
}

if (window.parent !== window) {
  window.addEventListener('resize', checkHeightAndNotifyParent) // update height on resize
  window.addEventListener('load', checkHeightAndNotifyParent) // initial size

  // ---------------- update height on DOM mutations ----------------
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
  if (MutationObserver) {
    const observer = new MutationObserver(function (mutations) {
      checkHeightAndNotifyParent()
    })

    observer.observe(document, { childList: true, subtree: true })

    const _onbeforeunload = window.onbeforeunload

    window.onbeforeunload = function (evt) {
      _onbeforeunload && _onbeforeunload(evt)
      observer.disconnect()
    }
  }

  // Also check size in timeout, because loaded images change document height
  window.setInterval(function () {
    checkHeightAndNotifyParent()
  }, 500)
  // ---------------- / update height on DOM mutations ----------------
}
